import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import enCommon from '@/locales/en/common.json'
import jaCommon from '@/locales/ja/common.json'

// Initialize i18next with resources and language detection
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      ja: { common: jaCommon },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ja'],
    defaultNS: 'common',
    ns: ['common'],
    interpolation: { escapeValue: false },
    detection: {
      // Prefer URL query (?lng=ja), then localStorage, then browser settings, then <html lang>
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  })

// Keep <html lang> in sync
i18n.on('initialized', () => {
  document.documentElement.lang = i18n.language
})

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})

export default i18n
